<div class="container">
    <h2 class="text-secondary">Solicitudes de servicio recibidas</h2>

    <br>
    <br>

    <div>
        <h6 class="text-secondary fw-bold">Búsqueda por rango de fechas de las solicitudes de servicio</h6>

        <div class="card rounded-0 border-bottom-0 border-end-0 border-start-0 border-secondary border-3">
            <br>
            <div class="row">
                <div class="col-md-3">
                    <label for="id" class="form-label">Tipo de Fecha</label>
                    <select class="form-select" aria-label="Default select example"
                        [(ngModel)]="dataSearch.tipoFiltroId" name="tipoFecha"
                        #tipoFecha="ngModel" required>
                        <option selected disabled>Seleccionar</option>
                        <option *ngFor="let typeFilterDate of $parametricList.typeFilterDate"
                            [value]="typeFilterDate.idParametroDetalle">
                            {{ typeFilterDate.vcNombre }}
                        </option>
                    </select>

                    <strong class="invalid-feedback d-block"
                        *ngIf="tipoFecha.invalid && (tipoFecha.dirty || tipoFecha.touched)">
                        <span *ngIf="tipoFecha.errors?.['required']">
                            Campo obligatorio
                        </span>
                    </strong>
                </div>

                <div class="col-md-3">
                    <label for="dtFechaInicial" class="form-label">Fecha Inicial</label>
                    <input id="dtFechaInicial" class="form-control" type="date" required
                        [(ngModel)]="dataSearch.dtFechaInicial" #fechaInicial="ngModel" name="dtFechaInicial"
                        [max]="dataSearch.dtFechaFinal">

                    <strong class="invalid-feedback d-block"
                        *ngIf="fechaInicial.invalid && (fechaInicial.dirty || fechaInicial.touched)">
                        <span *ngIf="fechaInicial.errors?.['required']">
                            Campo obligatorio
                        </span>
                    </strong>
                </div>

                <div class="col-md-3">
                    <label for="dtFechaFinal" class="form-label">Fecha Final</label>
                    <input id="dtFechaFinal" class="form-control" type="date" required
                        [(ngModel)]="dataSearch.dtFechaFinal" #fechaFinal="ngModel" name="dtFechaFinal"
                        [min]="dataSearch.dtFechaInicial">

                    <strong class="invalid-feedback d-block"
                        *ngIf="fechaFinal.invalid && (fechaFinal.dirty || fechaFinal.touched)">
                        <span *ngIf="fechaFinal.errors?.['required']">
                            Campo obligatorio
                        </span>
                    </strong>
                </div>

                <div class="col-md-1"></div>

                <div class="d-flex flex-column col-md-2 mt-2">
                    <br>
                    <button class="btn btn-secondary"
                        (click)="onSearchDates()"
                        [disabled]="tipoFecha.invalid || fechaInicial.invalid || fechaFinal.invalid">
                            BUSCAR
                    </button>
                </div>
            </div>
        </div>
    </div>

    <br>
    <br>

    <div>
        <app-table-consult-programmer
            [dataTable]="dataTable">
        </app-table-consult-programmer>

        <br>

        <div class="d-flex flex-row justify-content-center">
            <app-pagination [data]="paginationResponse" (setPagination)="getSolicitudes($event)">
            </app-pagination>
        </div>
    </div>

    <div>
        <h6 class="text-secondary fw-bold">Solicitud de servicio extemporánea</h6>

        <div class="card d-flex container rounded-0 border-bottom-0 border-end-0 border-start-0 border-secondary border-3">
            <br>

            <span>Desea radicar una solicitud de servicio extemporánea</span>
            <br>
            <button class="btn btn-secondary col-md-2" (click)="onShowRequest()" [disabled]="showRequest">
                ACEPTAR
            </button>
        </div>

        <br>

        <div class="py-4" *ngIf="showRequest">
            <div class="py-4">
                <app-solicitud-servicio 
                    [title]="'Solicitud de servicio extemporánea'" 
                    [submitted]="submitted" 
                    (SolicitudEvent)="catchRequestService($event)" 
                    [$views]="8">
                </app-solicitud-servicio>
            </div>
        
            <div class="container d-flex flex-row-reverse">
                <div class="col-2">
                    <button type="button" class="btn btn-secondary col-12" 
                    (click)="saveRequestService()">
                        SOLICITAR
                    </button>
                </div>
            </div>
        </div>

        <br>
        <br>
    </div>

    <br>
    <br>

    <div>
        <h6 class="text-secondary fw-bold">Consulta de los informes de las solicitudes de servicio</h6>

        <div class="card d-flex container rounded-0 border-bottom-0 border-end-0 border-start-0 border-secondary border-3">
            <br>

            <span>Desea consultar los informes de las solicitudes de servicio para identificar los indicadores y tendencias de los registros de las peticiones de servicio</span>
            <br>
            <button class="btn btn-secondary col-md-2" [routerLink]="['/informes-solicitudes-servicio']">
                ACEPTAR
            </button>
        </div>

    </div>

    <br>
    <br>
    <br>
</div>